import Vue from "vue";
import VueRouter from "vue-router";
import store from "../store";
import Home from "../components/Home";
import AuthHandler from "../views/auth/AuthHandler";
import Signin from "../views/auth/Signin";
import Signup from "../views/auth/Signup";
import Menu from "../components/Menu";
import Funding from "../views/application/Funding";
import FundingDetails from "../views/application/FundingDetails";
import Invitation from "../views/invitation/Invitation";
import AddFund from "../views/add-fund/AddFund";
import Withdraw from "../views/withdraws/Withdraw";
import InvesteeInfo from "../components/InvesteeInfo";
import Division from "../views/setting/Division";
import District from "../views/setting/District";
import Gender from "../views/setting/Gender";
import MaritalStatus from "../views/setting/MaritalStatus";
import GovApprovedId from "../views/setting/GovApprovedId";
import EmploymentType from "../views/setting/EmploymentType";
import EmploymentTypeDetail from "../views/setting/EmploymentTypeDetail";
import MonthlyIncomeType from "../views/setting/MonthlyIncomeType";
import EducationalQualificationType from "../views/setting/EducationalQualificationType";
import AccountType from "../views/setting/AccountType";
import Contacts from "../views/setting/Contacts";
import OtpCredential from "../views/setting/OtpCredential";
import OtpSms from "../views/setting/OtpSms";
import Faq from "../views/setting/Faq";
import UserType from "../views/setting/UserType";
import Investee from "../views/investee/Investee";
import InvesteeAllData from "../views/investee/InvesteeAllData";
import FundStatusList from "../views/investee/FundStatusList";
import EmiStatusList from "../views/investee/EmiStatusList";
import LoanPurpose from "../views/investee/LoanPurpose";
import HouseType from "../views/investee/HouseType";
import AllFee from "../views/investee/AllFee";
import NetWorthType from "../views/investor/NetWorthType";
import InvestorQuestion from "../views/investor/InvestorQuestion";
import InvestorQuestionAnswer from "../views/investor/InvestorQuestionAnswer";
import InvestorCalculatorSetting from "../views/investor/InvestorCalculatorSetting";
import MoneyAdjustmentStatus from "../views/investor/MoneyAdjustmentStatus";
import InvestorPaymentMethod from "../views/investor/InvestorPaymentMethod";
import WalletType from "../views/investor/WalletType";
import InvestExperienceType from "../views/investor/InvestExperienceType";
import InvestRiskType from "../views/investor/InvestRiskType";
import Url from "../views/user-role-permission/Url";
import Role from "../views/user-role-permission/Role";
import User from "../views/user-role-permission/User";
import UrlToRole from "../views/user-role-permission/UrlToRole";
import RoleToUser from "../views/user-role-permission/RoleToUser";
import UpdatePassword from "../views/user-role-permission/UpdatePassword";
import MakePayment from "../views/actions/MakePayment";
import ValidateNid from "../views/actions/ValidateNid";
import LoanProducts from "../views/loan-products/LoanProducts";
import LoanProductDetails from "../views/loan-products/LoanProductDetails";
import Users from "../views/users/Users";
import UserDetails from "../views/users/UserDetails";
import BankStatement from "../views/bank-statement/BankStatement";
import BankStatementUpload from "../views/bank-statement/BankStatementUpload";

Vue.use(VueRouter);

const router = new VueRouter({
  routes: [
    { path: "/", name: "Home", component: Home },
    //authentication
    { path: "/oauth2/callback", name: "auth handler", component: AuthHandler },
    { path: "/signin", name: "signin", component: Signin },
    { path: "/signup", name: "signup", component: Signup },

    { path: "/menu", name: "menu", component: Menu },

    //shadhin
    { path: "/loan-products", name: "LoanProducts", component: LoanProducts },
    {
      path: "/loan-product/:id",
      name: "LoanProductDetails",
      component: LoanProductDetails,
    },
    { path: "/funding", name: "Funding", component: Funding },
    {
      path: "/funding/:id",
      name: "FundingDetails",
      component: FundingDetails,
    },
    { path: "/users", name: "Users", component: Users },
    {
      path: "/user/:mobile",
      name: "UserDetails",
      component: UserDetails,
    },
    { path: "/invitation", name: "Invitation", component: Invitation },
    { path: "/make-payment", name: "Make Payment", component: MakePayment },
    { path: "/validate-nid", name: "Validate Nid", component: ValidateNid },

    //investor
    { path: "/add-fund", name: "Add Fund Request", component: AddFund },
    { path: "/withdraw", name: "Withdrawals", component: Withdraw },

    //investee-info
    { path: "/investee-info", name: "Investee Info", component: InvesteeInfo },

    //Setting
    { path: "/division", name: "Division", component: Division },
    { path: "/district", name: "District", component: District },
    { path: "/gender", name: "Gender", component: Gender },
    {
      path: "/marital-status",
      name: "Marital Status",
      component: MaritalStatus,
    },
    {
      path: "/gov-approved-id",
      name: "Gov Approved Id",
      component: GovApprovedId,
    },
    {
      path: "/employment-type",
      name: "Employment Type",
      component: EmploymentType,
    },
    {
      path: "/employment-type-detail",
      name: "Employment Type Detail",
      component: EmploymentTypeDetail,
    },
    {
      path: "/monthly-income-type",
      name: "Monthly Income type",
      component: MonthlyIncomeType,
    },
    {
      path: "/educational-qualification-type",
      name: "Educational Qualification type",
      component: EducationalQualificationType,
    },
    { path: "/account-type", name: "Account type", component: AccountType },
    { path: "/contacts", name: "Contacts", component: Contacts },
    {
      path: "/otp-credential",
      name: "Otp Credential",
      component: OtpCredential,
    },
    { path: "/otp-sms", name: "Otp Sms", component: OtpSms },
    { path: "/faq", name: "Faq", component: Faq },
    { path: "/user-type", name: "User Type", component: UserType },

    //investee
    { path: "/investee", name: "Investee", component: Investee },
    {
      path: "/investee-all-data",
      name: "Investee All Data",
      component: InvesteeAllData,
    },
    {
      path: "/fund-status-list",
      name: "Fund Status List",
      component: FundStatusList,
    },
    {
      path: "/emi-status-list",
      name: "Emi Status List",
      component: EmiStatusList,
    },
    {
      path: "/loan-purposes",
      name: "Loan Purposes",
      component: LoanPurpose,
    },
    { path: "/house-type", name: "House Type", component: HouseType },
    { path: "/all-fee", name: "All Fee", component: AllFee },

    // investor
    {
      path: "/net-worth-type",
      name: "Net Worth Type",
      component: NetWorthType,
    },
    {
      path: "/investor-question",
      name: "Investor Question",
      component: InvestorQuestion,
    },
    {
      path: "/investor-answer",
      name: "Investor Question Answer",
      component: InvestorQuestionAnswer,
    },
    {
      path: "/calculator-setting",
      name: "Investor Calaculator Setting",
      component: InvestorCalculatorSetting,
    },
    {
      path: "/money-adjust-status",
      name: "Investor Money Adjustment Status",
      component: MoneyAdjustmentStatus,
    },
    {
      path: "/payment-method",
      name: "Investor Payment Method",
      component: InvestorPaymentMethod,
    },
    { path: "/wallet-type", name: "Wallet Type", component: WalletType },
    {
      path: "/invest-experience-type",
      name: "Invest Experience Type",
      component: InvestExperienceType,
    },
    {
      path: "/invest-risk-type",
      name: "Invest Risk type",
      component: InvestRiskType,
    },

    //user role permission
    { path: "/url", name: "Url", component: Url },
    { path: "/role", name: "Role", component: Role },
    { path: "/official-user", name: "User", component: User },
    { path: "/url-role", name: "UrlToRole", component: UrlToRole },
    { path: "/role-user", name: "RoleToUser", component: RoleToUser },
    {
      path: "/update-password",
      name: "UpdatePassword",
      component: UpdatePassword,
    },
    {
      path: "/bank-statement",
      name: "BankStatement",
      component: BankStatement,
    },
    {
      path: "/bank-statement-upload",
      name: "BankStatementUpload",
      component: BankStatementUpload,
    },
  ],
  mode: "hash",
});

// Ensures all pending axios requests are cancelled on route change
router.beforeEach((to, from, next) => {
  store.dispatch("CANCEL_PENDING_REQUESTS");
  next();
});

export default router;
